import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useScrollTrigger,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  Assessment,
  Map,
  Schedule,
  AttachMoney,
} from '@mui/icons-material';

const navLinks = [
  { to: '/dashboard',          label: 'Dashboard',        icon: <DashboardIcon fontSize="small" /> },
  { to: '/risk-assessment',    label: 'Risk Assessment',  icon: <Assessment fontSize="small" /> },
  { to: '/geographic-analysis',label: 'Geographic',       icon: <Map fontSize="small" /> },
  { to: '/diagnostic-delay',   label: 'Diagnostic Delay', icon: <Schedule fontSize="small" /> },
  { to: '/economic-impact',    label: 'Economic Impact',  icon: <AttachMoney fontSize="small" /> },
];

const Navigation: React.FC = () => {
  const location = useLocation();
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: 10 });

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: scrolled
          ? 'rgba(255,255,255,0.92)'
          : 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid',
        borderColor: scrolled ? '#eceef8' : 'transparent',
        transition: 'all 0.25s ease',
        boxShadow: scrolled
          ? '0 2px 12px rgba(91,106,240,0.08)'
          : 'none',
      }}
    >
      <Toolbar sx={{ px: { xs: 2, sm: 3 }, minHeight: '64px !important' }}>
        {/* Logo */}
        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 0,
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: '1.05rem',
            letterSpacing: '-0.02em',
            mr: 4,
            background: 'linear-gradient(135deg, #5b6af0 0%, #9b59b6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          InvisibleIllness.AI
        </Typography>

        {/* Nav links */}
        <Box sx={{ flexGrow: 1, display: 'flex', gap: 0.5 }}>
          {navLinks.map(({ to, label, icon }) => {
            const active = location.pathname === to;
            return (
              <Button
                key={to}
                component={RouterLink}
                to={to}
                startIcon={icon}
                disableElevation
                sx={{
                  color: active ? '#5b6af0' : '#6b7194',
                  backgroundColor: active ? 'rgba(91,106,240,0.08)' : 'transparent',
                  fontWeight: active ? 600 : 500,
                  fontSize: '0.8125rem',
                  borderRadius: 8,
                  px: 1.5,
                  py: 0.75,
                  minWidth: 'unset',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    color: '#5b6af0',
                    backgroundColor: 'rgba(91,106,240,0.06)',
                  },
                }}
              >
                {label}
              </Button>
            );
          })}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;

// Made with Bob
